/** Replacement reason enum (CMS API) — dropdown shows the same string for label and value. */
export const CARD_REPLACEMENT_REASON_OPTIONS = [
    'LOST',
    'DAMAGED',
    'EXPIRED',
    'UPGRADE',
    'WEAR_AND_TEAR',
    'CUSTOMER_REQUEST',
    'SECURITY_ISSUE',
    'FRAUD_SUSPECTED',
].map(v => ({ name: v, value: v }));
/** Default source channel when creating a replacement via minimal CMS API (`POST …/minimal`). */
export const CARD_REPLACEMENT_DEFAULT_SOURCE_CHANNEL = 'BRANCH';
